import script from "./QuoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteForm.vue?vue&type=script&setup=true&lang=js"

import "./QuoteForm.vue?vue&type=style&index=0&id=3d43fc70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d43fc70"]])

export default __exports__